<template>
  <nav class="menu-container">

    <RouterLink
      :exact="item.exact"
      v-for="item in items"
      :key="item.link"
      :to="{ name: item.name }"
      active-class="selected"
      exact-active-class=""
    >
      <div class="icon">
        <Icon :type="item.icon" />
      </div>
      <span>{{ item.title }}</span>
    </RouterLink>
    购物公园站<br>
站点介绍<br>
购物公园站位于深圳市民田路下，呈南北方向布置。北侧为福华路，有规划地块和购物公园；南侧为福华三路，有城中雅苑和星河国际花城住宅小区；西侧有中海华庭；东侧为星河Cocopark。 车站采用地下三层岛式站台，其中地下一层为站厅层，地下二层为设备层，地下三层为站台层，两端为设备管理区，与1号线购物公园站在站厅付费区采用通道换乘。车站出入口采用自然采光设计，既美观又环保。车站周边多为高档写字楼及购物场所，车站装修以白色为主体，象征着高贵、时尚。该站为地下站。<br><br>
运营时刻表(工作日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
罗湖	06:07	23:52	1号线	2分钟	4分40秒<br>
机场东	06:36	23:16	1号线	2分钟	4分40秒<br>
福保	06:20	00:07	3号线	2分15-20秒	4分30秒<br>
双龙	06:24	23:06	3号线	2分15-20秒	4分30秒<br><br>
运营时刻表(休息日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
罗湖	06:07	23:50	1号线	3分45秒	5分45秒<br>
机场东	06:36	23:16	1号线	3分45秒	5分45秒<br>
福保	06:27	00:06	3号线	3分15秒	5分钟<br>
双龙	06:25	23:06	3号线	3分15秒	5分钟<br><br>
运营时刻表(节假日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
罗湖	06:07	00:50	1号线	3分45秒	5分45秒<br>
机场东	06:36	00:16	1号线	3分45秒	5分45秒<br>
福保	06:27	01:06	3号线	3分15秒	5分钟<br>
双龙	06:25	00:06	3号线	3分15秒	5分钟<br><br>
<br>
站点出口信息<br><br>
A出入口:<br>
福华路北侧（东）、益田路（北）、福田高铁站、连城新天地<br><br>
B出入口:<br>
福华路北侧（西）、民田路（北）、购物公园、投资大厦、公交接驳站、连城新天地会购区间、卓越大厦、航天大厦、华融大厦、中国人寿大厦<br><br>
C出入口:<br>
福华路南侧（西）、民田路（南）、福田星河COCO PARK<br><br>
D出入口:<br>
福华路南侧（东）、益田路（南）、云际观光层、深圳柏悦酒店、福田香格里拉大酒店<br><br>
公交换乘信息<br><br>
A出入口:<br>
公交站名： 购物公园地铁站<br>
3、64、316、398、B613、B709、E38、M417、M223、M224、M454、M459、M519、高峰专线17号、E10、高快巴士31号、M194、709、E38<br><br>
B出入口:<br>
公交站名： 购物公园公交接驳站<br>
398、3、E38、E1、高峰17、E20、M223、M224、E10、E25、B613<br><br>
C出入口:<br>
公交站名： 购物公园地铁站<br>
3、64、316、398、B613、B709、E38、M417、M223、M224、M454、M459、M519、高峰专线17号、E10、高快巴士31号、M194<br>
</nav>
</template>

<script>
// import Icon from "@/components/Icon";
export default {
  components: {
    // Icon,
  },
  data() {
    return {
      items: [
        {
          name: "yihaoxian",
          title: "1号线",
          // icon: "chat",
          exact: true,
        },
        {
          name: "sanhaoxian",
          title: "3号线",
          // icon: "chat",
          exact: true,
        },
      ],
    };
  },
};
</script>

<style scoped lang="less">
@import "~@/styles/var.less";
.menu-container {
  color: @words;
  margin: 24px 0;
  a {
    &.selected {
      background: darken(@words, 3%);
    }
    padding: 0 50px;
    display: block;
    display: flex;
    align-items: center;
    height: 45px;
    // .icon {
    //   width: 24px;
    // }
    &:hover {
      color: rgb(50, 95, 227);
    }
  }
}
</style>






